import ButtonUpload from "../componentes/buttonUpload"
import { collection, query, where, getDocs } from "firebase/firestore"
import { db } from "../firebaseConect"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import FileManager from "../componentes/test-newPageHome/newFilesUP"
import SharedByMeList from "../componentes/SharedByMeList"
import "../Css/FilePage.css"
import MenuUser from "../componentes/MenuUser"
import CreateFileMenu from "../componentes/CreateFileMenu"
import { useContextMenu } from "../hooks/useContextMenu"

export default function TestPage() {
  const [user, setUser] = useState(null)
  const [userEmail, setUserEmail] = useState(null)
  const [loading, setLoading] = useState(true)
  const [token, setToken] = useState(null)
  const [sharedByMeFiles, setSharedByMeFiles] = useState([])
  const [activeTab, setActiveTab] = useState("myfiles") // Añadido para manejar pestañas
  const navigate = useNavigate()

  // 🎯 Hook para menú contextual
  const { isOpen: isMenuOpen, position: menuPosition, openMenu, closeMenu } = useContextMenu()

  // Cargar datos del usuario al inicio
  useEffect(() => {
    
    console.log("🔍 Cargando datos de usuario en TestPage...")
    const token = localStorage.getItem("authToken")
    const userId = getCookieFromDocument("userId")
    const email = localStorage.getItem("userEmail")

    console.log("📧 Email encontrado:", email)
    console.log("🆔 UserId encontrado:", userId ? "Sí" : "No")

    setUserEmail(email)

    if (token && userId && email) {
      setToken(token)
      setUser({ id: userId, email })
    } else {
      console.warn("⚠️ Datos de usuario incompletos")
    }

    setLoading(false)
  }, [])

  useEffect(() => {
  // Solo cargar si la pestaña activa es "sharedbyme" y hay email
  if (activeTab === "sharedbyme" && userEmail) {
    const fetchSharedByMe = async () => {
      const q = query(collection(db, "sharedFile"), where("owner", "==", userEmail))
      const querySnapshot = await getDocs(q)
      const files = []
      querySnapshot.forEach((docSnap) => {
        files.push({ id: docSnap.id, ...docSnap.data() })
      })
      setSharedByMeFiles(files)
    }
    fetchSharedByMe()
  }
}, [activeTab, userEmail])

  // Redirigir si no hay usuario
  useEffect(() => {
    if (!loading && !user) {
      console.log("🚫 Usuario no autenticado, redirigiendo...")
      navigate("/login")
    }
  }, [loading, user, navigate])

  function getCookieFromDocument(name) {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) return parts.pop().split(";").shift()
    return null
  }

  // 🎯 Manejar creación de archivo desde menú contextual
  const handleFileCreated = (newFile) => {
    console.log("✅ Nuevo archivo creado:", newFile)

    // Actualizar la lista de archivos
    //handleGetFiles()

    // Mostrar notificación
    alert(`✅ ${newFile.fileName} creado exitosamente!`)
  }

  // Manejador para cambiar de pestaña
  const handleTabChange = (tab) => {
    console.log("🔄 Cambiando a pestaña:", tab)
    setActiveTab(tab)
  }

  if (loading) {
    return (
      <div className="app-loading">
        <div className="spinner-large"></div>
        <p>Cargando tu nube privada...</p>
      </div>
    )
  }

  if (!user) {
    return (
      <div className="auth-required">
        <div className="auth-required-content">
          <div className="auth-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
            </svg>
          </div>
          <h2>Acceso Restringido</h2>
          <p>Debes iniciar sesión para acceder a tu nube privada</p>
          <div className="auth-buttons">
            <a href="/login" className="btn-login">
              Iniciar Sesión
            </a>
            <a href="/register" className="btn-register">
              Registrarse
            </a>
          </div>
        </div>
      </div>
    )
  }

  console.log("🖥️ Renderizando TestPage con email:", userEmail, "y modo:", activeTab)

  return (
    <div className="app-container"
        onContextMenu={e => {
        e.preventDefault(); // Evita el menú nativo
        openMenu(e);        // Abre tu menú contextual personalizado
    }}
    >
      <header className="app-header">
        <div className="app-header-content">
          <div className="app-logo">CloudPriv</div>
          <nav className="app-nav">
            <a href="/" className="nav-link">
              Inicio
            </a>
            <a
              href="#"
              className={`nav-link${activeTab === "myfiles" ? " active" : ""}`}
              onClick={(e) => {
                e.preventDefault()
                handleTabChange("myfiles")
              }}
            >
              Mis Archivos
            </a>
            <a
              href="#"
              className={`nav-link${activeTab === "shared" ? " active" : ""}`}
              onClick={(e) => {
                e.preventDefault()
                handleTabChange("shared")
              }}
            >
              Compartidos
            </a>
            <a
              href="#"
              className={`nav-link${activeTab === "sharedbyme" ? " active" : ""}`}
              onClick={e => { e.preventDefault(); setActiveTab("sharedbyme") }}
            >
              Compartidos por mí
            </a>
            <a href="#" className="nav-link">
              Papelera
            </a>
          </nav>
          <div className="user-menu">
            <MenuUser
              userEmail={userEmail || "Usuario"}
              onLogout={() => {
                // Eliminar el token y redirigir al login
                localStorage.removeItem("authToken")
                localStorage.removeItem("userEmail")
                document.cookie = "userId=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT"
                navigate("/login")
              }}
            />
          </div>
        </div>
      </header>

      <main className="app-main">
        {activeTab === "sharedbyme" ? (
          <SharedByMeList sharedFiles={sharedByMeFiles} />
        ) : (
          <FileManager mode={activeTab} userEmail={userEmail} />
        )}

              {/* 🎯 Menú contextual para crear archivos */}
              <CreateFileMenu
                isOpen={isMenuOpen}
                position={menuPosition}
                onClose={closeMenu}
                onFileCreated={handleFileCreated}
              />
      </main>



      <footer className="app-footer">
        <p>&copy; 2024 CloudPriv. Todos los derechos reservados.</p>
      </footer>
    </div>
  )
}